import { useState, useEffect } from "react";
import { useApiCall } from "./useApiCall";
import { useRouter } from "next/router";

export const useProduct = (autoFetch = true) => {
  const [currentHandle, setCurrentHandle] = useState();
  const [product, setProduct] = useState();
  const [productStatus, setProductStatus] = useState("idle");
  const [productError, setProductError] = useState();
  const { executeApiCall, apiCallResponse, apiCallStatus } = useApiCall();
  const router = useRouter();

  const fetchProduct = (productHandle) => {
    if (productHandle) {
      setProductStatus("pending");

      const requestOptions = {
        url: `/products/${productHandle}`,
      };

      executeApiCall(requestOptions);

      setProductError();
      setProduct();
    }
  };

  useEffect(() => {
    if (autoFetch === true) {
      const { productHandle, productId } = router.query;

      const handle = productHandle || productId;

      if (handle && currentHandle !== handle) {
        setCurrentHandle(handle);

        fetchProduct(handle);
      }
    }
  }, [currentHandle, router, autoFetch]);

  useEffect(() => {
    switch (apiCallStatus) {
      case "success":
        if (apiCallResponse?.data?.data) {
          const { product } = apiCallResponse.data.data;

          setProduct(product);
          setProductStatus("ready");
        }

        if (apiCallResponse?.data?.error) {
          const { error } = apiCallResponse.data;

          setProductError(error.userMessage);
          setProductStatus("ready");
        }
        break;
      case "error":
        setProductStatus("ready");
        break;
    }
  }, [apiCallStatus, apiCallResponse]);

  return {
    fetchProduct,
    product,
    productStatus,
    productError,
  };
};
